import { MatDialogRef } from '@angular/material/dialog';

export abstract class BaseDialogComponent<T> {
  protected constructor(protected dialogRef: MatDialogRef<T>) {}

  close(): void {
    this.dialogRef.close();
  }
}
